// 分页大小
export const PAGE_SIZE = {
    DEFAULT: 20,
};

// 超时时间
export const TIME_OUT = {
    DEFAULT: 6000,
};
